/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Operation types that FE needs to know what to do with a specific message.
 */
export enum OperationType {
  CREATE = 'CREATE',
  APPEND = 'APPEND',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  REPLACE = 'REPLACE',
}
